import cx from 'classnames';
import { ReactNode, Ref } from 'react';

import style from './Container.module.css';

type ContainerVariant = 'default' | 'fluid' | 'cover';

const variantClass: Record<ContainerVariant, string> = {
    default: style.default,
    fluid: style.fluid,
    cover: style.cover,
};

type ContainerProps = {
    children: ReactNode;
    variant?: ContainerVariant;
    id?: string;
    className?: string;
    ref?: Ref<HTMLDivElement>;
    testId?: string;
};

export function Container({
    children,
    variant = 'default',
    id,
    className,
    ref,
    testId = 'Container',
}: ContainerProps) {
    return (
        <div
            data-testid={testId}
            id={id}
            className={cx(variantClass[variant], className)}
            ref={ref}
        >
            {children}
        </div>
    );
}
